const getListWithNewTitle = (list, textPattern) => {
  return list.map(listItem => {
    return {
      ...listItem,
      name: textPattern.replace('%s', listItem.city),
      url: `www.goibibo.com${listItem.url}`
    };
  });
};

export default getListWithNewTitle;
